"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _getStateKeyFromApiPath = _interopRequireDefault(require("./getStateKeyFromApiPath"));

var _getStateKeyFromUrl = _interopRequireDefault(require("./getStateKeyFromUrl"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getStateKeyFromConfig(config) {
  var apiPath = config.apiPath,
      url = config.url;
  if (config.stateKey === null) return null;
  return config.stateKey || apiPath && (0, _getStateKeyFromApiPath["default"])(apiPath) || url && (0, _getStateKeyFromUrl["default"])(url);
}

var _default = getStateKeyFromConfig;
exports["default"] = _default;